// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3-container {
	padding: 16px;
	background: linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%);
	min-height: calc(100vh - 80px);
	color: #0f172a;
	transform-origin: top left;
	zoom: 0.9;
}

/* =========================
   Fancy Loading Spinner
========================= */

.a3-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
}

.a3-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #215f99;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.a3-loading-text {
  font-size: 16px;
  font-weight: 500;
  color: #475569;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.a3-loading-dots::after {
  content: '';
  animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
  0%, 20% { content: '.'; }
  40% { content: '..'; }
  60%, 100% { content: '...'; }
}

@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* =========================
   Fancy Refresh Button
========================= */

.a3-refresh-button {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
  color: #334155 !important;
  border: 1.5px solid #cbd5e1 !important;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  font-weight: 600 !important;
  padding: 10px 18px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.a3-refresh-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transition: left 0.6s ease;
}

.a3-refresh-button:hover {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%) !important;
  border-color: #a5b4fc !important;
  color: #4338ca !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
}

.a3-refresh-button:hover::before {
  left: 100%;
}

.a3-refresh-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.15);
}

.a3-refresh-icon {
  display: inline-block;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.a3-refresh-button:hover .a3-refresh-icon {
  transform: rotate(-360deg);
  animation: smoothSpin 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes smoothSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

/* =========================
   A3 Detail Top Bar
========================= */

.a3-detail-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.a3-detail-back-btn {
  background: none;
  border: none;
  color: #215f99;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  padding: 6px 0;
  text-decoration: none;
  transition: color 0.15s;
}

.a3-detail-back-btn:hover {
  color: #174a78;
  text-decoration: underline;
}

.a3-detail-edit-btn {
  background: #e2e8f0;
  color: #1e293b;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.a3-detail-edit-btn:hover {
  background: #cbd5e1;
}
.a3-title {
	margin: 0 0 6px;
	color: #17324d;
	font-size: 24px;
	font-weight: 800;
}
.a3-subtitle {
	margin: 0 0 24px;
	font-size: 14px;
	color: #5f6c7b;
	font-weight: 400;
}
.form-group { margin-bottom: 14px; }
.form-label { display: block; margin-bottom: 8px; font-weight: 700; color: #0b314a; font-size: 15px; }
.input {
	width: 100%;
	padding: 8px 10px;
	font-size: 15px;
	border-radius: 6px;
	border: 1px solid rgba(11,49,74,0.06);
	background: #fff;
	box-shadow: inset 0 1px 1px rgba(2,6,23,0.02);
}
.textarea {
	width: 100%;
	padding: 8px 10px;
	font-size: 15px;
	font-family: inherit;
	border-radius: 6px;
	border: 1px solid rgba(11,49,74,0.06);
	background: #fff;
	box-shadow: inset 0 1px 1px rgba(2,6,23,0.02);
}

/* autogrow: disable manual resize and hide native scrollbars; grow to fit content */
.textarea.autogrow {
	resize: none;
	overflow: hidden;
	transition: height 120ms ease;
}
.section-card {
	background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
	border-radius: 10px;
	box-shadow: 0 6px 16px rgba(2,6,23,0.05);
	padding: 10px;
	margin-bottom: 12px;
	border: 1px solid rgba(2,6,23,0.05);
}
.section-header { display: flex; justify-content: space-between; align-items: center; }
.section-header strong { font-size: 1rem; color: #092135; }
.section-header strong { display: inline-flex; align-items: center; gap: 8px; }
.section-actions { display: flex; gap: 8px; }
.btn {
	padding: 4px 8px;
	font-size: 12px;
	border-radius: 8px;
	border: none;
	background: linear-gradient(90deg, #06b6d4 0%, #0ea5a4 50%, #0369a1 100%);
	color: white;
	cursor: pointer;
	box-shadow: 0 4px 8px rgba(3,105,161,0.08);
	transition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;
}
.btn:hover { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(3,105,161,0.12); }
.btn:active { transform: translateY(0); }
.btn.btn-secondary {
	background: transparent;
	color: #044a66;
	border: 1px solid rgba(4,74,102,0.12);
	box-shadow: none;
}
.controls { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.preview { margin-top: 20px; }

/* Ensure top-level action buttons in the controls area use the same visual style */
.controls > .btn,
.controls > .btn.btn-secondary,
.sidebar-controls > .btn,
.a3-modal .modal-actions > .btn {
	/* inherit the base .btn rules; these selectors ensure buttons here remain consistent */
	padding: 6px 12px;
	font-size: 13px;
	border-radius: 8px;
	min-height: 36px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

/* spacing between adjacent action buttons */
.controls > .btn + .btn { margin-left: 8px; }

/* Primary action buttons — always show dark-blue gradient like .btn */
.controls > .btn:not(.btn-secondary),
.controls > .btn:not(.btn-secondary):hover {
	background: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);
	color: #ffffff;
	padding: 8px 16px;
	font-weight: 600;
	font-size: 13px;
	border-radius: 8px;
	box-shadow: 0 6px 18px rgba(3,105,161,0.18);
	transform: none;
	border: none;
}

/* keep secondary buttons as light tabs */
.controls > .btn.btn-secondary {
	/* treat reset in the controls as a primary action visually */
	background: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);
	color: #ffffff;
	box-shadow: 0 6px 18px rgba(3,105,161,0.18);
}
.preview-title { margin-bottom: 10px; color: #063247; }
.preview-block {
	border-radius: 8px;
	padding: 10px;
	background: #ffffff;
	box-shadow: 0 6px 16px rgba(2,6,23,0.05);
	border-left: 4px solid rgba(3,105,161,0.10);
}
.modal-backdrop {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(2,6,23,0.45);
	z-index: 1200;
	padding: 24px;
}
.a3-modal {
	max-width: 1600px;
	width: 100%;
	outline: none;
	display: flex;
	flex-direction: column;
	gap: 12px;
	position: relative;
	/* keep modal within viewport and allow scrolling when content is tall */
	max-height: calc(100vh - 48px);
	overflow: auto;
	overflow-x: hidden;
}
.a3-modal-header { display: flex; align-items: center; justify-content: space-between; }
.a3-sheet {
	background: #f8fafc;
	padding: 12px;
	border-radius: 6px;
	box-shadow: 0 10px 30px rgba(2,6,23,0.3);
	display: flex;
	overflow-x: hidden; /* prevent horizontal scrollbar */
	justify-content: center;
	width: 100%;
}
/* Emulate A3 proportions: approx 29.7cm x 42.0cm -> aspect ratio 1.414 */
.a3-sheet-inner {
	width: 100%;
	max-width: 1500px; /* allow wider A3-like canvas */
	background: white;
	border: 1px solid rgba(2,6,23,0.06);
	padding: 18px;
	box-shadow: inset 0 1px 0 rgba(2,6,23,0.02);
	/* allow inner scrolling when the page content is very long */
	max-height: calc(100vh - 240px);
	overflow: auto;
	/* prevent horizontal overflow from very long words */
	overflow-x: hidden;
	box-sizing: border-box;
	display: flex;
	justify-content: center;

/* Also ensure the page itself can't cause horizontal scroll when scaled */
.a3-page { max-width: 100%; box-sizing: border-box; }
}

@media (max-width: 900px) {
	.a3-sheet-inner { padding: 16px; }
}
.preview-section { margin-bottom: 14px; }
.preview-heading { margin-bottom: 6px; color: #083047; font-size: 1rem; }
.generated-json-block { margin-top: 18px; }
.monospace { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace; }
.generated-json-block .textarea {
	background: #071423;
	color: #e6fffa;
	border: 1px solid rgba(255,255,255,0.04);
}
.preview-toggle { margin-left: auto; display: flex; align-items: center; gap: 8px; }

/* Responsive tweaks */
@media (max-width: 700px) {
	.controls { flex-direction: column; align-items: stretch; }
	.preview-toggle { margin-left: 0; }
}

.sidebar-layout { display: grid; grid-template-columns: 280px 1fr; gap: 18px; margin-top: 12px; align-items: start; }
.sidebar { background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%); border-radius: 8px; padding: 12px; box-shadow: 0 6px 16px rgba(2,6,23,0.05); border: 1px solid rgba(2,6,23,0.05); display: flex; flex-direction: column; }
.sidebar-header { margin-bottom: 12px; }
.sections-list { display: flex; flex-direction: column; gap: 8px; flex: 1 1 auto; overflow: auto; padding-right: 6px; }
.section-list-item { padding: 8px; border-radius: 6px; cursor: pointer; border: 1px solid transparent; position: relative; }
.section-list-item.active { background: linear-gradient(90deg, rgba(6,182,212,0.08), rgba(3,105,161,0.04)); border-color: rgba(3,105,161,0.08); }
.section-mini { display: flex; justify-content: space-between; align-items: center; }
.section-mini-title { font-weight: 600; font-size: 14px; color: #082e40; }
.section-mini-actions { display: flex; gap: 6px; }
.sidebar-controls { margin-top: auto; display: flex; gap: 8px; }

/* Make Add Section / Reset in the sidebar match the builder-tabs / controls style */
.sidebar-controls > .btn:not(.btn-secondary) {
	background: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);
	color: #ffffff;
	padding: 8px 16px;
	font-weight: 600;
	font-size: 13px;
	border-radius: 8px;
	box-shadow: 0 6px 18px rgba(3,105,161,0.18);
	border: none;
}
.sidebar-controls > .btn.btn-secondary {
	/* Reset in sidebar should also look like a primary action */
	background: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);
	color: #ffffff;
	box-shadow: 0 6px 18px rgba(3,105,161,0.18);
}
.sidebar-controls > .btn + .btn { margin-left: 8px; }

/* Small arrow and delete buttons in the section list also use dark-blue */
.section-mini-actions .btn.small {
	background: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);
	color: #ffffff;
	padding: 4px 8px;
	font-size: 12px;
	border-radius: 6px;
	box-shadow: 0 6px 14px rgba(3,105,161,0.14);
}
.section-mini-actions .btn.small:hover { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(3,105,161,0.16); }

/* small button style used in sidebar */
.btn.small { padding: 2px 6px; font-size: 11px; border-radius: 6px; }
.btn.small:hover { transform: none; }

/* small numbered badge used in the section list */
.mini-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #0369a1;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  margin-right: 8px;
  flex-shrink: 0;
}

/* Cause Analysis row layout */
.cause-row { margin-top: 8px; }
.cause-row .form-label { font-size: 15px; margin-bottom: 6px; }
.cause-row .input { padding: 8px; font-size: 15px; }
.cause-row input::placeholder { color: rgba(6,55,80,0.35); }

/* Countermeasure row uses same layout as cause row */
.counter-row { margin-top: 8px; }
.counter-row .form-label { font-size: 15px; margin-bottom: 6px; }
.counter-row .input { padding: 8px; font-size: 15px; }
.counter-row input::placeholder { color: rgba(6,55,80,0.35); }

/* Action Plan row layout */
.action-row { margin-top: 8px; }
.action-row .form-label { font-size: 15px; margin-bottom: 6px; }
.action-row .input { padding: 8px; font-size: 15px; }
.action-row input[type=date] { padding: 6px 8px; }
.action-row select.input { padding: 6px 8px; }

/* Lesson rows and Results styling */
.lesson-row { margin-top: 8px; }
.lesson-row .form-label { font-size: 15px; margin-bottom: 6px; }
.lesson-row .input { padding: 8px; font-size: 15px; }
.lesson-row input::placeholder { color: rgba(6,55,80,0.35); }

.btn.btn-secondary { background: transparent; color: #044a66; border: 1px solid rgba(4,74,102,0.12); box-shadow: none; padding: 8px 12px; border-radius: 8px; }
.btn.btn-secondary:hover { background: rgba(3,105,161,0.06); }

@media (max-width: 900px) { .sidebar-layout { grid-template-columns: 1fr; } .sections-list { max-height: 36vh; } }

/* modal close button - prominent circular accent */
.modal-close {
	/* prominent, high-contrast close button that stays on top */
	position: fixed;
	top: 18px;
	right: 18px;
	width: 48px;
	height: 48px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 999px;
	background: #06b6d4; /* accent teal */
	color: #ffffff;
	font-weight: 800;
	font-size: 18px;
	border: 3px solid #ffffff; /* white ring to separate from background */
	box-shadow: 0 10px 30px rgba(3,105,161,0.28), 0 2px 6px rgba(2,6,23,0.12);
	cursor: pointer;
	z-index: 9999; /* ensure it's above all modal content */
	transition: transform 120ms ease, box-shadow 120ms ease;
}
.modal-close:hover { transform: scale(1.08); }
.modal-close:focus {
	outline: none;
	box-shadow: 0 0 0 6px rgba(6,182,212,0.18), 0 10px 30px rgba(3,105,161,0.28);
}

/* A3 page preview styles */
.a3-page { position: relative; background: #fbfdff; padding: 28px; border-radius: 6px; box-shadow: 0 8px 30px rgba(2,6,23,0.08); font-family: Inter, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.28; color: #0b2130; }
.a3-page { box-sizing: border-box; width: 100%; }
.a3-page-accent { position: absolute; left: 0; top: 0; bottom: 0; width: 8px; background: linear-gradient(180deg,#06b6d4,#0369a1); border-radius: 6px 0 0 6px; }
.a3-header { display:flex; justify-content:space-between; align-items:center; gap:12px; margin-bottom: 18px; }
.a3-title-large { margin:0; font-size:1.05rem; color:#053247; }
.a3-sub { color:#0b314a; font-size:11px; }
.a3-badge { background: #0369a1; color: white; padding:5px 8px; border-radius:6px; font-weight:700; font-size:12px; }
.a3-body {
	display: grid;
	grid-template-columns: 1fr 1fr; /* two columns: left/right */
	gap: 18px 24px;
	align-items: start;
}
.a3-section-card { background: white; border:1px solid rgba(2,6,23,0.04); padding:10px; border-radius:8px; }
.a3-section-heading {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	border-radius: 999px;
	background: none;
	color: #092135;
	font-weight: 800;
	font-size: 15px;
	margin-bottom: 6px;
}
.a3-section-heading .num,
.a3-section-heading .section-num {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #e0eaf3 !important;
	color: #0369a1 !important;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 900;
}
.a3-section-content { 
	white-space: pre-wrap;
	color: #0b2130;
	font-family: inherit;
	overflow-wrap: anywhere; /* allow long strings to wrap */
	word-wrap: break-word;
	word-break: break-word;
	hyphens: auto;
	display: block;
	max-width: 100%;
	box-sizing: border-box;
	font-size: 15px;
	font-weight: normal;
}

/* images or other media inside preview should scale to container */
.a3-section-content img { max-width: 100%; height: auto; display: block; }

/* Slight overall zoom-out for the preview to show more content */
.a3-modal .a3-page {
	transform: scale(0.85); /* stronger zoom-out to show more content */
	transform-origin: top center;
}

/* Also slightly scale down inline preview when the page is wide to better fit container */
.a3-sheet .a3-page {
	transform: scale(0.98);
	transform-origin: top center;
}

/* Ensure the page fills the available sheet inner area */
.a3-page { max-width: 1450px; width: 100%; }

@media (max-width: 980px) {
	.a3-body { grid-template-columns: 1fr; }
	.a3-modal .a3-page { transform: scale(0.95); }
	.a3-sheet .a3-page { transform: none; }
}
.a3-footer { margin-top: 16px; font-size:12px; color:#55707f; text-align:right; }

.builder-tabs {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  margin-bottom: 16px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%);
  padding: 12px 0;
  margin-left: -16px;
  margin-right: -16px;
  padding-left: 16px;
  padding-right: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #e2e8f0;
}

.builder-tabs { align-items: center; justify-content: space-between; }

.tab-links { display: flex; gap: 10px; align-items: center; }
.tab-actions { display: flex; gap: 8px; align-items: center; }

.btab {
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  background: #e2e8f0;
  color: #334155;
	font-weight: 600;
	/* match other action buttons */
	font-family: Inter, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	font-size: 13px;
  transition: all 0.2s ease;
}

.btab:hover {
  background: #cbd5e1;
}

.btab.active {
  background: #0369a1;
  color: #ffffff;
}

/* make primary buttons show same dark-blue active state as the builder tab */
.btn:not(.btn-secondary):active,
.btn:not(.btn-secondary):focus,
.controls > .btn:not(.btn-secondary):active,
.controls > .btn:not(.btn-secondary):focus,
.sidebar-controls > .btn:not(.btn-secondary):active,
.sidebar-controls > .btn:not(.btn-secondary):focus {
	background: #0369a1;
	color: #ffffff;
	box-shadow: 0 8px 20px rgba(3,105,161,0.12);
	transform: translateY(0);
}

/* keyboard focus visible state */
.btn:focus-visible {
	outline: none;
	box-shadow: 0 0 0 4px rgba(3,105,161,0.12), 0 8px 20px rgba(3,105,161,0.12);
}

.a3sheet {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-top: 12px;
  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.08);
}

.sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.htitle {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.hsub {
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
}

.a3grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
}

.box {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
}

.box h3 {
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  color: #0f172a;
  font-size: 14px;
}

.num {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e0eaf3;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
  font-size: 12px;
  font-weight: 900;
  flex-shrink: 0;
}

.preview-content {
  white-space: pre-wrap;
  line-height: 1.55;
  color: #334155;
  font-size: 13px;
  word-break: break-word;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  hyphens: auto;
  max-width: 100%;
  box-sizing: border-box;
}

.a3-body .a3grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}

@media (max-width: 768px) {
  .a3grid {
    grid-template-columns: 1fr;
  }

	.builder-tabs {
		flex-direction: column;
		align-items: stretch;
		gap: 8px;
	}

	.tab-actions { justify-content: flex-start; }
}

.b-section{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:18px 20px;box-shadow:var(--shadow);margin-bottom:16px}
  .b-section h3{margin:0 0 14px;font-size:12.5px;font-weight:800;color:var(--primary-dark);text-transform:uppercase;letter-spacing:.03em;display:flex;align-items:center;gap:8px}
	.b-section h3 .num{width:19px;height:19px;border-radius:50%;background:var(--primary);color:#fff;font-size:10.5px;display:inline-flex;align-items:center;justify-content:center;font-weight:800}
  .b-section label{display:block;font-size:11px;font-weight:800;color:var(--heading);margin:12px 0 5px}
  .b-section label:first-of-type{margin-top:0}
  .b-section input[type=text],.b-section input[type=number],.b-section textarea,.b-section select{width:100%;border:1.5px solid var(--border);border-radius:8px;padding:8px 10px;font-size:12.5px}
  .b-section textarea{resize:vertical;min-height:64px}
  .b-section label.chk{display:flex;align-items:center;gap:6px;font-weight:700}
  .b-section label.chk input[type=checkbox]{width:auto}
  .b-grid2{display:grid;grid-template-columns:1fr 1fr;gap:0 16px}
  .b-grid2 .fullwidth{grid-column:1/-1}

/* Tighter A3 visual refinements */
.b-section {
	background: #ffffff;
	border: 1px solid #e6eef6;
	border-radius: 12px;
	padding: 16px;
	box-shadow: 0 6px 18px rgba(3,37,63,0.04);
}
.b-section h3 { font-size: 13px; letter-spacing: 0.02em; color: #062a44; }
.b-section label { font-size: 12px; color: #0b3746; margin: 8px 0 6px; display:block; font-weight:700 }
.b-section input[type=text], .b-section input[type=number], .b-section select, .b-section textarea {
	height: 36px; padding: 8px 10px; font-size: 13px; border-radius: 8px; border: 1px solid #d7e6ef;
	background: #fbfdff;
}
.b-section textarea { min-height: 72px; padding-top: 10px; padding-bottom: 10px }
.b-section input[disabled] { background: #f3f7fa; color: #5b6b73 }
.b-grid2 { grid-auto-rows: minmax(36px, auto); gap: 10px 16px }

/* table styles inside preview to look more like Word tables */
.a3table { width: 100%; border-collapse: collapse; margin-top: 6px; table-layout: fixed; }
.a3table th, .a3table td { padding: 8px 10px; border: 1px solid #e6eef6; font-size: 15px; font-family: inherit; font-weight: normal; text-align: left; word-break: break-word; overflow-wrap: anywhere; word-wrap: break-word; white-space: pre-wrap; hyphens: auto; }
.a3table thead th { background: #f1f7fb; color: #093241; font-weight:700 }

/* metric chips */
.metric-strip { display:flex; gap:8px; margin-top:8px }
.metric-chip { padding:6px 10px; background:#eef6fb; border-radius:999px; font-weight: normal; color:#063247; font-size:15px; font-family: inherit; }
.metric-chip.good { background:#ecfdf5; color:#065f46 }
.metric-chip.bad { background:#fff7f5; color:#9b1c1c }

/* status badges */
.status-badge { display:inline-block; padding:4px 10px; border-radius:999px; font-weight:800; font-size:12px; color:#fff }
.status-badge.completed { background: #10b981 }
.status-badge.inprogress { background: #f59e0b }
.status-badge.notstarted { background: #64748b }

/* savings card */
.savings-card { border-radius: 8px; background: linear-gradient(180deg,#f8fafc,#ffffff); padding: 12px; display:flex; flex-direction:column; align-items:flex-end; justify-content:center; width:180px; border:1px solid #e6eef6 }
.savings-card.empty { opacity: 0.7 }
.savings-card .amt { font-size: 18px; font-weight:800; color:#073047 }
.savings-card .lbl { font-size:12px; color:#64748b }

/* lighter blue savings card inside Results section */
.savings-card-dark {
  border-radius: 10px;
  background: #0369a1;
  padding: 14px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;  /* fill the full height of the parent flex row */
  min-width: 180px;
  box-shadow: 0 4px 14px rgba(3,37,63,0.18);
}
.savings-card-dark .scd-amt {
  font-size: 22px;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 0.01em;
  line-height: 1.1;
}
.savings-card-dark .scd-lbl {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,0.72);
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* Results section box layout: content on left, savings card fills full right side */
.results-box {
  display: flex;
  align-items: stretch;
  gap: 0;
}
.results-box-content {
  flex: 1 1;
  padding-right: 16px;
}
.results-box-savings {
  display: flex;
  flex-shrink: 0;
}
.results-box-savings .savings-card-dark {
  border-radius: 8px;
  width: 160px;
  min-height: 100%;
}

/* row inside Results heading area to push savings card to the right */
.results-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

/* small helper spacing */
.box-content {
  font-size: 15px;
  font-family: inherit;
  font-weight: normal;
  color: #153241;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  hyphens: auto;
  max-width: 100%;
  box-sizing: border-box;
}


/* New: section heading styled as pill with number */
.section-heading-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;

    padding: 8px 12px;
    border-radius: 999px;

    background: none;

    color: #174a78;   /* Legacy blue */
    font-weight: 800;
    font-size: 15px;

    text-transform: uppercase;
    letter-spacing: 0.03em;
}
.section-heading-button .num {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #e0eaf3 !important;
	color: #0369a1 !important;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 900;
	margin-right: 0;
}

/* Restyle main form action buttons to match the heading pill style */
.form-button {
	background: #0369a1;
	color: #fff;
	padding: 10px 18px;
	border-radius: 999px;
	border: none;
	font-weight: 700;
	box-shadow: 0 8px 22px rgba(3,105,161,0.18);
}
.form-button:hover { background: #025a8a; transform: translateY(-2px); box-shadow: 0 12px 30px rgba(3,105,161,0.26); }
.form-button:active { background: #024f7a; transform: translateY(0); }

.cancel-button {
	background: #fff !important;
	color: #4b5563 !important;
	border: 1px solid #d1d5db !important;
	box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
	margin-right: 8px;
}
.cancel-button:hover {
	background: #f9fafb !important;
	border-color: #9ca3af !important;
	color: #1f2937 !important;
}

/* Inline single-line preview header (Industrial Engineer, Site/DC, Date, Status, Title) */
.preview-inline-header {
	display: flex;
	align-items: flex-end;
	gap: 18px;
	padding: 6px 8px 12px 8px;
	border-bottom: 2px solid rgba(6,55,80,0.08); /* underline */
}

.preview-inline-header .preview-inline-item { display: flex; flex-direction: column; min-width: 80px; }
.preview-inline-header .title-only { display:flex; flex-direction: column; align-items: flex-start; justify-content: center; min-width: 360px; min-height: 44px; }
.preview-inline-header .title-value { font-size: 18px; font-weight: 900; color: #032d44; text-align: left; }
.preview-inline-header .preview-inline-item.title-only label { display: none; }
.preview-inline-header .preview-inline-item.title-only .preview-inline-value { padding: 0; }
.preview-inline-right { display:flex; align-items:flex-end; gap:10px; margin-left: auto; }
.preview-inline-header label { font-size: 12px; font-weight: 800; color: #0a3042; margin-bottom: 4px; }
.preview-inline-value { font-size: 15px; font-family: inherit; font-weight: normal; color: #062a44; word-break: break-word; overflow-wrap: anywhere; max-width: 100%; }
.preview-inline-value .placeholder { color: #64748b; font-weight: normal; }
.placeholder { color: #64748b; font-style: italic; font-weight: normal; font-size: 15px; font-family: inherit; }

/* Layout helpers used by both A3Builder preview and A3Detail */
.left-col,
.right-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.full-width-row {
  display: block;
}

@media (max-width: 980px) {
	.preview-inline-header { flex-direction: column; align-items: stretch; gap: 8px; }
	.preview-inline-header .title-item { margin-left: 0; }
}

.box .section-heading-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 999px;
    background: none;
    color: #092135;
    font-weight: 800;
    font-size: 13px;
    margin-bottom: 12px;
}

.box .section-heading-button,
.b-section .section-heading-button {
    color: #174a78 !important;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: .03em;
}

.box .section-heading-button .num,
.b-section .section-heading-button .num {
    background: #215f99 !important;
    color: #fff !important;
}

/* =========================
   Common Reusable Patterns
========================= */

/* Field Container */
.a3-field-container {
  display: flex;
  flex-direction: column;
}

/* Grid Layouts */
.a3-grid-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.a3-grid-gap {
  display: grid;
  gap: 12px;
}

.a3-grid-gap-mb {
  display: grid;
  gap: 12px;
  margin-bottom: 12px;
}

.a3-flex-col-gap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Section Description */
.a3-section-description {
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  color: #64748b;
  margin: 0 0 10px 0;
}

.a3-section-description-no-margin {
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* Required Field Asterisk */
.a3-required-asterisk {
  color: #d32f2f;
  margin-left: 4px;
  font-weight: bold;
}

/* Add Button Icon */
.a3-add-button-icon {
  font-size: 22px;
  line-height: 1;
  font-weight: 400;
}

/* Not Documented Placeholder */
.a3-not-documented {
  font-style: italic;
  font-weight: 400;
  color: #64748b;
}

/* Row Container with Flex End */
.a3-row-container {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

/* Flex Layouts */
.a3-flex-center-gap {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Metric Input Width */
.a3-metric-input {
  width: 60%;
}

/* Metric Flag Label */
.a3-metric-flag-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #000000;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

/* Metric Flag Checkbox */
.a3-metric-flag-checkbox {
  accent-color: #dc2626;
  width: 14px;
  height: 14px;
}

/* Preview Subtitle */
.a3-preview-subtitle {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  margin-top: 3px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* Min Width Helpers */
.a3-min-width-80 {
  min-width: 80px;
}

.a3-min-width-60 {
  min-width: 60px;
}

/* Margin Top Helper */
.a3-mt-8 {
  margin-top: 8px;
}

.a3-mt-12 {
  margin-top: 12px;
}

.a3-mt-16 {
  margin-top: 16px;
}

/* Text Align */
.a3-text-left {
  text-align: left;
}

/* Results Box Padding */
.results-box-padding {
  padding: 16px;
  flex: 1 1;
}

/* Results Section Heading Margin */
.results-heading-margin {
  margin: 0 0 10px 0;
}

/* Results Box Container */
.results-box-flex-container {
  display: flex;
  align-items: flex-start;
  gap: 0;
  padding: 0;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/ieHub/A3Builder.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,6DAA6D;CAC7D,8BAA8B;CAC9B,cAAc;CACd,0BAA0B;CAC1B,SAAS;AACV;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,UAAU,YAAY,EAAE;EACxB,MAAM,aAAa,EAAE;EACrB,YAAY,cAAc,EAAE;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,wEAAwE;EACxE,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,4DAA4D;EAC5D,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;AACA;CACC,eAAe;CACf,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;AACA,cAAc,mBAAmB,EAAE;AACnC,cAAc,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACrG;CACC,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,qCAAqC;CACrC,gBAAgB;CAChB,6CAA6C;AAC9C;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,qCAAqC;CACrC,gBAAgB;CAChB,6CAA6C;AAC9C;;AAEA,oFAAoF;AACpF;CACC,YAAY;CACZ,gBAAgB;CAChB,6BAA6B;AAC9B;AACA;CACC,6DAA6D;CAC7D,mBAAmB;CACnB,wCAAwC;CACxC,aAAa;CACb,mBAAmB;CACnB,mCAAmC;AACpC;AACA,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACtF,yBAAyB,eAAe,EAAE,cAAc,EAAE;AAC1D,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9E,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C;CACC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,yEAAyE;CACzE,YAAY;CACZ,eAAe;CACf,0CAA0C;CAC1C,2EAA2E;AAC5E;AACA,aAAa,2BAA2B,EAAE,2CAA2C,EAAE;AACvF,cAAc,wBAAwB,EAAE;AACxC;CACC,uBAAuB;CACvB,cAAc;CACd,qCAAqC;CACrC,gBAAgB;AACjB;AACA,YAAY,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3E,WAAW,gBAAgB,EAAE;;AAE7B,mFAAmF;AACnF;;;;CAIC,uFAAuF;CACvF,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA,4CAA4C;AAC5C,0BAA0B,gBAAgB,EAAE;;AAE5C,sEAAsE;AACtE;;CAEC,4DAA4D;CAC5D,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,2CAA2C;CAC3C,eAAe;CACf,YAAY;AACb;;AAEA,yCAAyC;AACzC;CACC,6DAA6D;CAC7D,4DAA4D;CAC5D,cAAc;CACd,2CAA2C;AAC5C;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,wCAAwC;CACxC,2CAA2C;AAC5C;AACA;CACC,eAAe;CACf,QAAQ;CACR,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,aAAa;AACd;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;CAClB,wEAAwE;CACxE,8BAA8B;CAC9B,cAAc;CACd,kBAAkB;AACnB;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACvF;CACC,mBAAmB;CACnB,aAAa;CACb,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,kBAAkB,EAAE,iCAAiC;CACrD,uBAAuB;CACvB,WAAW;AACZ;AACA,yEAAyE;AACzE;CACC,WAAW;CACX,iBAAiB,EAAE,+BAA+B;CAClD,iBAAiB;CACjB,mCAAmC;CACnC,aAAa;CACb,2CAA2C;CAC3C,6DAA6D;CAC7D,+BAA+B;CAC/B,cAAc;CACd,qDAAqD;CACrD,kBAAkB;CAClB,sBAAsB;CACtB,aAAa;CACb,uBAAuB;;AAExB,0EAA0E;AAC1E,WAAW,eAAe,EAAE,sBAAsB,EAAE;AACpD;;AAEA;CACC,kBAAkB,aAAa,EAAE;AAClC;AACA,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AACxE,wBAAwB,gBAAgB,EAAE;AAC1C,aAAa,iGAAiG,EAAE;AAChH;CACC,mBAAmB;CACnB,cAAc;CACd,wCAAwC;AACzC;AACA,kBAAkB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEnF,sBAAsB;AACtB;CACC,YAAY,sBAAsB,EAAE,oBAAoB,EAAE;CAC1D,kBAAkB,cAAc,EAAE;AACnC;;AAEA,kBAAkB,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpH,WAAW,6DAA6D,EAAE,kBAAkB,EAAE,aAAa,EAAE,wCAAwC,EAAE,mCAAmC,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACnO,kBAAkB,mBAAmB,EAAE;AACvC,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACtH,qBAAqB,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,6BAA6B,EAAE,kBAAkB,EAAE;AAC3H,4BAA4B,8EAA8E,EAAE,kCAAkC,EAAE;AAChJ,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACpF,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACzE,wBAAwB,aAAa,EAAE,QAAQ,EAAE;AACjD,oBAAoB,gBAAgB,EAAE,aAAa,EAAE,QAAQ,EAAE;;AAE/D,oFAAoF;AACpF;CACC,4DAA4D;CAC5D,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,2CAA2C;CAC3C,YAAY;AACb;AACA;CACC,4DAA4D;CAC5D,4DAA4D;CAC5D,cAAc;CACd,2CAA2C;AAC5C;AACA,kCAAkC,gBAAgB,EAAE;;AAEpD,0EAA0E;AAC1E;CACC,4DAA4D;CAC5D,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,2CAA2C;AAC5C;AACA,yCAAyC,2BAA2B,EAAE,2CAA2C,EAAE;;AAEnH,uCAAuC;AACvC,aAAa,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACpE,mBAAmB,eAAe,EAAE;;AAEpC,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B,aAAa,eAAe,EAAE;AAC9B,yBAAyB,eAAe,EAAE,kBAAkB,EAAE;AAC9D,oBAAoB,YAAY,EAAE,eAAe,EAAE;AACnD,gCAAgC,yBAAyB,EAAE;;AAE3D,qDAAqD;AACrD,eAAe,eAAe,EAAE;AAChC,2BAA2B,eAAe,EAAE,kBAAkB,EAAE;AAChE,sBAAsB,YAAY,EAAE,eAAe,EAAE;AACrD,kCAAkC,yBAAyB,EAAE;;AAE7D,2BAA2B;AAC3B,cAAc,eAAe,EAAE;AAC/B,0BAA0B,eAAe,EAAE,kBAAkB,EAAE;AAC/D,qBAAqB,YAAY,EAAE,eAAe,EAAE;AACpD,+BAA+B,gBAAgB,EAAE;AACjD,2BAA2B,gBAAgB,EAAE;;AAE7C,oCAAoC;AACpC,cAAc,eAAe,EAAE;AAC/B,0BAA0B,eAAe,EAAE,kBAAkB,EAAE;AAC/D,qBAAqB,YAAY,EAAE,eAAe,EAAE;AACpD,iCAAiC,yBAAyB,EAAE;;AAE5D,qBAAqB,uBAAuB,EAAE,cAAc,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC9J,2BAA2B,gCAAgC,EAAE;;AAE7D,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE,iBAAiB,gBAAgB,EAAE,EAAE;;AAEjH,mDAAmD;AACnD;CACC,4DAA4D;CAC5D,eAAe;CACf,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,oBAAoB;CACpB,mBAAmB,EAAE,gBAAgB;CACrC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,yBAAyB,EAAE,2CAA2C;CACtE,yEAAyE;CACzE,eAAe;CACf,aAAa,EAAE,wCAAwC;CACvD,uDAAuD;AACxD;AACA,qBAAqB,sBAAsB,EAAE;AAC7C;CACC,aAAa;CACb,4EAA4E;AAC7E;;AAEA,2BAA2B;AAC3B,WAAW,kBAAkB,EAAE,mBAAmB,EAAE,aAAa,EAAE,kBAAkB,EAAE,wCAAwC,EAAE,2EAA2E,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjP,WAAW,sBAAsB,EAAE,WAAW,EAAE;AAChD,kBAAkB,kBAAkB,EAAE,OAAO,EAAE,MAAM,EAAE,SAAS,EAAE,UAAU,EAAE,mDAAmD,EAAE,0BAA0B,EAAE;AAC/J,aAAa,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC7G,kBAAkB,QAAQ,EAAE,iBAAiB,EAAE,aAAa,EAAE;AAC9D,UAAU,aAAa,EAAE,cAAc,EAAE;AACzC,YAAY,mBAAmB,EAAE,YAAY,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE;AACpH;CACC,aAAa;CACb,8BAA8B,EAAE,4BAA4B;CAC5D,cAAc;CACd,kBAAkB;AACnB;AACA,mBAAmB,iBAAiB,EAAE,kCAAkC,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC3G;CACC,oBAAoB;CACpB,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,oBAAoB;CACpB,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,8BAA8B;CAC9B,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,cAAc;CACd,oBAAoB;CACpB,uBAAuB,EAAE,+BAA+B;CACxD,qBAAqB;CACrB,sBAAsB;CACtB,aAAa;CACb,cAAc;CACd,eAAe;CACf,sBAAsB;CACtB,eAAe;CACf,mBAAmB;AACpB;;AAEA,mEAAmE;AACnE,0BAA0B,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE;;AAEzE,iEAAiE;AACjE;CACC,sBAAsB,EAAE,2CAA2C;CACnE,4BAA4B;AAC7B;;AAEA,0FAA0F;AAC1F;CACC,sBAAsB;CACtB,4BAA4B;AAC7B;;AAEA,yDAAyD;AACzD,WAAW,iBAAiB,EAAE,WAAW,EAAE;;AAE3C;CACC,WAAW,0BAA0B,EAAE;CACvC,qBAAqB,sBAAsB,EAAE;CAC7C,qBAAqB,eAAe,EAAE;AACvC;AACA,aAAa,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAEhF;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA,gBAAgB,mBAAmB,EAAE,8BAA8B,EAAE;;AAErE,aAAa,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC5D,eAAe,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAE7D;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,2EAA2E;CAC3E,eAAe;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;;;;;;CAMC,mBAAmB;CACnB,cAAc;CACd,2CAA2C;CAC3C,wBAAwB;AACzB;;AAEA,iCAAiC;AACjC;CACC,aAAa;CACb,2EAA2E;AAC5E;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;CAED;EACC,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;CACT;;CAEA,eAAe,2BAA2B,EAAE;AAC7C;;AAEA,WAAW,yBAAyB,CAAC,8BAA8B,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,kBAAkB;EAClJ,cAAc,eAAe,CAAC,gBAAgB,CAAC,eAAe,CAAC,yBAAyB,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO;CAC/K,mBAAmB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,yBAAyB,CAAC,UAAU,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,eAAe;EAC9L,iBAAiB,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,iBAAiB;EACpG,+BAA+B,YAAY;EAC3C,gGAAgG,UAAU,CAAC,gCAAgC,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,gBAAgB;EAC/L,oBAAoB,eAAe,CAAC,eAAe;EACnD,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe;EAC5E,0CAA0C,UAAU;EACpD,SAAS,YAAY,CAAC,6BAA6B,CAAC,UAAU;EAC9D,oBAAoB,gBAAgB;;AAEtC,kCAAkC;AAClC;CACC,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,aAAa;CACb,yCAAyC;AAC1C;AACA,gBAAgB,eAAe,EAAE,sBAAsB,EAAE,cAAc,EAAE;AACzE,mBAAmB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE,gBAAgB;AACtG;CACC,YAAY,EAAE,iBAAiB,EAAE,eAAe,EAAE,kBAAkB,EAAE,yBAAyB;CAC/F,mBAAmB;AACpB;AACA,sBAAsB,gBAAgB,EAAE,iBAAiB,EAAE,qBAAqB;AAChF,6BAA6B,mBAAmB,EAAE,eAAe;AACjE,WAAW,kCAAkC,EAAE,eAAe;;AAE9D,8DAA8D;AAC9D,WAAW,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACzF,2BAA2B,iBAAiB,EAAE,yBAAyB,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE,qBAAqB,EAAE,aAAa,EAAE;AACrQ,oBAAoB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB;;AAEzE,iBAAiB;AACjB,gBAAgB,YAAY,EAAE,OAAO,EAAE,eAAe;AACtD,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE,oBAAoB,EAAE;AACpJ,oBAAoB,kBAAkB,EAAE,cAAc;AACtD,mBAAmB,kBAAkB,EAAE,cAAc;;AAErD,kBAAkB;AAClB,gBAAgB,oBAAoB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE,WAAW;AACzH,0BAA0B,oBAAoB;AAC9C,2BAA2B,oBAAoB;AAC/C,2BAA2B,oBAAoB;;AAE/C,iBAAiB;AACjB,gBAAgB,kBAAkB,EAAE,mDAAmD,EAAE,aAAa,EAAE,YAAY,EAAE,qBAAqB,EAAE,oBAAoB,EAAE,sBAAsB,EAAE,WAAW,EAAE,yBAAyB;AACjO,sBAAsB,aAAa;AACnC,qBAAqB,eAAe,EAAE,eAAe,EAAE,cAAc;AACrE,qBAAqB,cAAc,EAAE,cAAc;;AAEnD,qDAAqD;AACrD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,GAAG,gDAAgD;EACtE,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;AACR;AACA;EACE,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;;AAGA,oDAAoD;AACpD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;IACjB,oBAAoB;;IAEpB,gBAAgB;;IAEhB,cAAc,IAAI,gBAAgB;IAClC,gBAAgB;IAChB,eAAe;;IAEf,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,8BAA8B;CAC9B,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA,qEAAqE;AACrE;CACC,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,YAAY;CACZ,gBAAgB;CAChB,2CAA2C;AAC5C;AACA,qBAAqB,mBAAmB,EAAE,2BAA2B,EAAE,4CAA4C,EAAE;AACrH,sBAAsB,mBAAmB,EAAE,wBAAwB,EAAE;;AAErE;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,oCAAoC;CACpC,iDAAiD;CACjD,iBAAiB;AAClB;AACA;CACC,8BAA8B;CAC9B,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA,0FAA0F;AAC1F;CACC,aAAa;CACb,qBAAqB;CACrB,SAAS;CACT,yBAAyB;CACzB,2CAA2C,EAAE,cAAc;AAC5D;;AAEA,8CAA8C,aAAa,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACtG,qCAAqC,YAAY,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACjK,sCAAsC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3G,+DAA+D,aAAa,EAAE;AAC9E,+EAA+E,UAAU,EAAE;AAC3F,wBAAwB,YAAY,EAAE,oBAAoB,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACzF,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACtG,wBAAwB,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,eAAe,EAAE;AACtK,qCAAqC,cAAc,EAAE,mBAAmB,EAAE;AAC1E,eAAe,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE,oBAAoB,EAAE;;AAE/G,+DAA+D;AAC/D;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;AAChB;;AAEA;CACC,yBAAyB,sBAAsB,EAAE,oBAAoB,EAAE,QAAQ,EAAE;CACjF,qCAAqC,cAAc,EAAE;AACtD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;;2BAE2B;;AAE3B,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAO;AACT;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB","sourcesContent":[".a3-container {\n\tpadding: 16px;\n\tbackground: linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%);\n\tmin-height: calc(100vh - 80px);\n\tcolor: #0f172a;\n\ttransform-origin: top left;\n\tzoom: 0.9;\n}\n\n/* =========================\n   Fancy Loading Spinner\n========================= */\n\n.a3-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 20px;\n}\n\n.a3-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #215f99;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.a3-loading-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: #475569;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.a3-loading-dots::after {\n  content: '';\n  animation: dots 1.5s steps(4, end) infinite;\n}\n\n@keyframes dots {\n  0%, 20% { content: '.'; }\n  40% { content: '..'; }\n  60%, 100% { content: '...'; }\n}\n\n@keyframes slideDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* =========================\n   Fancy Refresh Button\n========================= */\n\n.a3-refresh-button {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;\n  color: #334155 !important;\n  border: 1.5px solid #cbd5e1 !important;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  font-weight: 600 !important;\n  padding: 10px 18px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.a3-refresh-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n  transition: left 0.6s ease;\n}\n\n.a3-refresh-button:hover {\n  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%) !important;\n  border-color: #a5b4fc !important;\n  color: #4338ca !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);\n}\n\n.a3-refresh-button:hover::before {\n  left: 100%;\n}\n\n.a3-refresh-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.15);\n}\n\n.a3-refresh-icon {\n  display: inline-block;\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n}\n\n.a3-refresh-button:hover .a3-refresh-icon {\n  transform: rotate(-360deg);\n  animation: smoothSpin 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes smoothSpin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n/* =========================\n   A3 Detail Top Bar\n========================= */\n\n.a3-detail-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.a3-detail-back-btn {\n  background: none;\n  border: none;\n  color: #215f99;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 6px 0;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.a3-detail-back-btn:hover {\n  color: #174a78;\n  text-decoration: underline;\n}\n\n.a3-detail-edit-btn {\n  background: #e2e8f0;\n  color: #1e293b;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.a3-detail-edit-btn:hover {\n  background: #cbd5e1;\n}\n.a3-title {\n\tmargin: 0 0 6px;\n\tcolor: #17324d;\n\tfont-size: 24px;\n\tfont-weight: 800;\n}\n.a3-subtitle {\n\tmargin: 0 0 24px;\n\tfont-size: 14px;\n\tcolor: #5f6c7b;\n\tfont-weight: 400;\n}\n.form-group { margin-bottom: 14px; }\n.form-label { display: block; margin-bottom: 8px; font-weight: 700; color: #0b314a; font-size: 15px; }\n.input {\n\twidth: 100%;\n\tpadding: 8px 10px;\n\tfont-size: 15px;\n\tborder-radius: 6px;\n\tborder: 1px solid rgba(11,49,74,0.06);\n\tbackground: #fff;\n\tbox-shadow: inset 0 1px 1px rgba(2,6,23,0.02);\n}\n.textarea {\n\twidth: 100%;\n\tpadding: 8px 10px;\n\tfont-size: 15px;\n\tfont-family: inherit;\n\tborder-radius: 6px;\n\tborder: 1px solid rgba(11,49,74,0.06);\n\tbackground: #fff;\n\tbox-shadow: inset 0 1px 1px rgba(2,6,23,0.02);\n}\n\n/* autogrow: disable manual resize and hide native scrollbars; grow to fit content */\n.textarea.autogrow {\n\tresize: none;\n\toverflow: hidden;\n\ttransition: height 120ms ease;\n}\n.section-card {\n\tbackground: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n\tborder-radius: 10px;\n\tbox-shadow: 0 6px 16px rgba(2,6,23,0.05);\n\tpadding: 10px;\n\tmargin-bottom: 12px;\n\tborder: 1px solid rgba(2,6,23,0.05);\n}\n.section-header { display: flex; justify-content: space-between; align-items: center; }\n.section-header strong { font-size: 1rem; color: #092135; }\n.section-header strong { display: inline-flex; align-items: center; gap: 8px; }\n.section-actions { display: flex; gap: 8px; }\n.btn {\n\tpadding: 4px 8px;\n\tfont-size: 12px;\n\tborder-radius: 8px;\n\tborder: none;\n\tbackground: linear-gradient(90deg, #06b6d4 0%, #0ea5a4 50%, #0369a1 100%);\n\tcolor: white;\n\tcursor: pointer;\n\tbox-shadow: 0 4px 8px rgba(3,105,161,0.08);\n\ttransition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;\n}\n.btn:hover { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(3,105,161,0.12); }\n.btn:active { transform: translateY(0); }\n.btn.btn-secondary {\n\tbackground: transparent;\n\tcolor: #044a66;\n\tborder: 1px solid rgba(4,74,102,0.12);\n\tbox-shadow: none;\n}\n.controls { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }\n.preview { margin-top: 20px; }\n\n/* Ensure top-level action buttons in the controls area use the same visual style */\n.controls > .btn,\n.controls > .btn.btn-secondary,\n.sidebar-controls > .btn,\n.a3-modal .modal-actions > .btn {\n\t/* inherit the base .btn rules; these selectors ensure buttons here remain consistent */\n\tpadding: 6px 12px;\n\tfont-size: 13px;\n\tborder-radius: 8px;\n\tmin-height: 36px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* spacing between adjacent action buttons */\n.controls > .btn + .btn { margin-left: 8px; }\n\n/* Primary action buttons — always show dark-blue gradient like .btn */\n.controls > .btn:not(.btn-secondary),\n.controls > .btn:not(.btn-secondary):hover {\n\tbackground: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);\n\tcolor: #ffffff;\n\tpadding: 8px 16px;\n\tfont-weight: 600;\n\tfont-size: 13px;\n\tborder-radius: 8px;\n\tbox-shadow: 0 6px 18px rgba(3,105,161,0.18);\n\ttransform: none;\n\tborder: none;\n}\n\n/* keep secondary buttons as light tabs */\n.controls > .btn.btn-secondary {\n\t/* treat reset in the controls as a primary action visually */\n\tbackground: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);\n\tcolor: #ffffff;\n\tbox-shadow: 0 6px 18px rgba(3,105,161,0.18);\n}\n.preview-title { margin-bottom: 10px; color: #063247; }\n.preview-block {\n\tborder-radius: 8px;\n\tpadding: 10px;\n\tbackground: #ffffff;\n\tbox-shadow: 0 6px 16px rgba(2,6,23,0.05);\n\tborder-left: 4px solid rgba(3,105,161,0.10);\n}\n.modal-backdrop {\n\tposition: fixed;\n\tinset: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: rgba(2,6,23,0.45);\n\tz-index: 1200;\n\tpadding: 24px;\n}\n.a3-modal {\n\tmax-width: 1600px;\n\twidth: 100%;\n\toutline: none;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n\tposition: relative;\n\t/* keep modal within viewport and allow scrolling when content is tall */\n\tmax-height: calc(100vh - 48px);\n\toverflow: auto;\n\toverflow-x: hidden;\n}\n.a3-modal-header { display: flex; align-items: center; justify-content: space-between; }\n.a3-sheet {\n\tbackground: #f8fafc;\n\tpadding: 12px;\n\tborder-radius: 6px;\n\tbox-shadow: 0 10px 30px rgba(2,6,23,0.3);\n\tdisplay: flex;\n\toverflow-x: hidden; /* prevent horizontal scrollbar */\n\tjustify-content: center;\n\twidth: 100%;\n}\n/* Emulate A3 proportions: approx 29.7cm x 42.0cm -> aspect ratio 1.414 */\n.a3-sheet-inner {\n\twidth: 100%;\n\tmax-width: 1500px; /* allow wider A3-like canvas */\n\tbackground: white;\n\tborder: 1px solid rgba(2,6,23,0.06);\n\tpadding: 18px;\n\tbox-shadow: inset 0 1px 0 rgba(2,6,23,0.02);\n\t/* allow inner scrolling when the page content is very long */\n\tmax-height: calc(100vh - 240px);\n\toverflow: auto;\n\t/* prevent horizontal overflow from very long words */\n\toverflow-x: hidden;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: center;\n\n/* Also ensure the page itself can't cause horizontal scroll when scaled */\n.a3-page { max-width: 100%; box-sizing: border-box; }\n}\n\n@media (max-width: 900px) {\n\t.a3-sheet-inner { padding: 16px; }\n}\n.preview-section { margin-bottom: 14px; }\n.preview-heading { margin-bottom: 6px; color: #083047; font-size: 1rem; }\n.generated-json-block { margin-top: 18px; }\n.monospace { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace; }\n.generated-json-block .textarea {\n\tbackground: #071423;\n\tcolor: #e6fffa;\n\tborder: 1px solid rgba(255,255,255,0.04);\n}\n.preview-toggle { margin-left: auto; display: flex; align-items: center; gap: 8px; }\n\n/* Responsive tweaks */\n@media (max-width: 700px) {\n\t.controls { flex-direction: column; align-items: stretch; }\n\t.preview-toggle { margin-left: 0; }\n}\n\n.sidebar-layout { display: grid; grid-template-columns: 280px 1fr; gap: 18px; margin-top: 12px; align-items: start; }\n.sidebar { background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%); border-radius: 8px; padding: 12px; box-shadow: 0 6px 16px rgba(2,6,23,0.05); border: 1px solid rgba(2,6,23,0.05); display: flex; flex-direction: column; }\n.sidebar-header { margin-bottom: 12px; }\n.sections-list { display: flex; flex-direction: column; gap: 8px; flex: 1 1 auto; overflow: auto; padding-right: 6px; }\n.section-list-item { padding: 8px; border-radius: 6px; cursor: pointer; border: 1px solid transparent; position: relative; }\n.section-list-item.active { background: linear-gradient(90deg, rgba(6,182,212,0.08), rgba(3,105,161,0.04)); border-color: rgba(3,105,161,0.08); }\n.section-mini { display: flex; justify-content: space-between; align-items: center; }\n.section-mini-title { font-weight: 600; font-size: 14px; color: #082e40; }\n.section-mini-actions { display: flex; gap: 6px; }\n.sidebar-controls { margin-top: auto; display: flex; gap: 8px; }\n\n/* Make Add Section / Reset in the sidebar match the builder-tabs / controls style */\n.sidebar-controls > .btn:not(.btn-secondary) {\n\tbackground: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);\n\tcolor: #ffffff;\n\tpadding: 8px 16px;\n\tfont-weight: 600;\n\tfont-size: 13px;\n\tborder-radius: 8px;\n\tbox-shadow: 0 6px 18px rgba(3,105,161,0.18);\n\tborder: none;\n}\n.sidebar-controls > .btn.btn-secondary {\n\t/* Reset in sidebar should also look like a primary action */\n\tbackground: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);\n\tcolor: #ffffff;\n\tbox-shadow: 0 6px 18px rgba(3,105,161,0.18);\n}\n.sidebar-controls > .btn + .btn { margin-left: 8px; }\n\n/* Small arrow and delete buttons in the section list also use dark-blue */\n.section-mini-actions .btn.small {\n\tbackground: linear-gradient(90deg, #0369a1 0%, #0369a1 100%);\n\tcolor: #ffffff;\n\tpadding: 4px 8px;\n\tfont-size: 12px;\n\tborder-radius: 6px;\n\tbox-shadow: 0 6px 14px rgba(3,105,161,0.14);\n}\n.section-mini-actions .btn.small:hover { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(3,105,161,0.16); }\n\n/* small button style used in sidebar */\n.btn.small { padding: 2px 6px; font-size: 11px; border-radius: 6px; }\n.btn.small:hover { transform: none; }\n\n/* small numbered badge used in the section list */\n.mini-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: #0369a1;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n/* Cause Analysis row layout */\n.cause-row { margin-top: 8px; }\n.cause-row .form-label { font-size: 15px; margin-bottom: 6px; }\n.cause-row .input { padding: 8px; font-size: 15px; }\n.cause-row input::placeholder { color: rgba(6,55,80,0.35); }\n\n/* Countermeasure row uses same layout as cause row */\n.counter-row { margin-top: 8px; }\n.counter-row .form-label { font-size: 15px; margin-bottom: 6px; }\n.counter-row .input { padding: 8px; font-size: 15px; }\n.counter-row input::placeholder { color: rgba(6,55,80,0.35); }\n\n/* Action Plan row layout */\n.action-row { margin-top: 8px; }\n.action-row .form-label { font-size: 15px; margin-bottom: 6px; }\n.action-row .input { padding: 8px; font-size: 15px; }\n.action-row input[type=date] { padding: 6px 8px; }\n.action-row select.input { padding: 6px 8px; }\n\n/* Lesson rows and Results styling */\n.lesson-row { margin-top: 8px; }\n.lesson-row .form-label { font-size: 15px; margin-bottom: 6px; }\n.lesson-row .input { padding: 8px; font-size: 15px; }\n.lesson-row input::placeholder { color: rgba(6,55,80,0.35); }\n\n.btn.btn-secondary { background: transparent; color: #044a66; border: 1px solid rgba(4,74,102,0.12); box-shadow: none; padding: 8px 12px; border-radius: 8px; }\n.btn.btn-secondary:hover { background: rgba(3,105,161,0.06); }\n\n@media (max-width: 900px) { .sidebar-layout { grid-template-columns: 1fr; } .sections-list { max-height: 36vh; } }\n\n/* modal close button - prominent circular accent */\n.modal-close {\n\t/* prominent, high-contrast close button that stays on top */\n\tposition: fixed;\n\ttop: 18px;\n\tright: 18px;\n\twidth: 48px;\n\theight: 48px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 999px;\n\tbackground: #06b6d4; /* accent teal */\n\tcolor: #ffffff;\n\tfont-weight: 800;\n\tfont-size: 18px;\n\tborder: 3px solid #ffffff; /* white ring to separate from background */\n\tbox-shadow: 0 10px 30px rgba(3,105,161,0.28), 0 2px 6px rgba(2,6,23,0.12);\n\tcursor: pointer;\n\tz-index: 9999; /* ensure it's above all modal content */\n\ttransition: transform 120ms ease, box-shadow 120ms ease;\n}\n.modal-close:hover { transform: scale(1.08); }\n.modal-close:focus {\n\toutline: none;\n\tbox-shadow: 0 0 0 6px rgba(6,182,212,0.18), 0 10px 30px rgba(3,105,161,0.28);\n}\n\n/* A3 page preview styles */\n.a3-page { position: relative; background: #fbfdff; padding: 28px; border-radius: 6px; box-shadow: 0 8px 30px rgba(2,6,23,0.08); font-family: Inter, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.28; color: #0b2130; }\n.a3-page { box-sizing: border-box; width: 100%; }\n.a3-page-accent { position: absolute; left: 0; top: 0; bottom: 0; width: 8px; background: linear-gradient(180deg,#06b6d4,#0369a1); border-radius: 6px 0 0 6px; }\n.a3-header { display:flex; justify-content:space-between; align-items:center; gap:12px; margin-bottom: 18px; }\n.a3-title-large { margin:0; font-size:1.05rem; color:#053247; }\n.a3-sub { color:#0b314a; font-size:11px; }\n.a3-badge { background: #0369a1; color: white; padding:5px 8px; border-radius:6px; font-weight:700; font-size:12px; }\n.a3-body {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr; /* two columns: left/right */\n\tgap: 18px 24px;\n\talign-items: start;\n}\n.a3-section-card { background: white; border:1px solid rgba(2,6,23,0.04); padding:10px; border-radius:8px; }\n.a3-section-heading {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 8px 12px;\n\tborder-radius: 999px;\n\tbackground: none;\n\tcolor: #092135;\n\tfont-weight: 800;\n\tfont-size: 15px;\n\tmargin-bottom: 6px;\n}\n.a3-section-heading .num,\n.a3-section-heading .section-num {\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 50%;\n\tbackground: #e0eaf3 !important;\n\tcolor: #0369a1 !important;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tfont-weight: 900;\n}\n.a3-section-content { \n\twhite-space: pre-wrap;\n\tcolor: #0b2130;\n\tfont-family: inherit;\n\toverflow-wrap: anywhere; /* allow long strings to wrap */\n\tword-wrap: break-word;\n\tword-break: break-word;\n\thyphens: auto;\n\tdisplay: block;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\tfont-size: 15px;\n\tfont-weight: normal;\n}\n\n/* images or other media inside preview should scale to container */\n.a3-section-content img { max-width: 100%; height: auto; display: block; }\n\n/* Slight overall zoom-out for the preview to show more content */\n.a3-modal .a3-page {\n\ttransform: scale(0.85); /* stronger zoom-out to show more content */\n\ttransform-origin: top center;\n}\n\n/* Also slightly scale down inline preview when the page is wide to better fit container */\n.a3-sheet .a3-page {\n\ttransform: scale(0.98);\n\ttransform-origin: top center;\n}\n\n/* Ensure the page fills the available sheet inner area */\n.a3-page { max-width: 1450px; width: 100%; }\n\n@media (max-width: 980px) {\n\t.a3-body { grid-template-columns: 1fr; }\n\t.a3-modal .a3-page { transform: scale(0.95); }\n\t.a3-sheet .a3-page { transform: none; }\n}\n.a3-footer { margin-top: 16px; font-size:12px; color:#55707f; text-align:right; }\n\n.builder-tabs {\n  display: flex;\n  gap: 10px;\n  margin-top: 14px;\n  margin-bottom: 16px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%);\n  padding: 12px 0;\n  margin-left: -16px;\n  margin-right: -16px;\n  padding-left: 16px;\n  padding-right: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.builder-tabs { align-items: center; justify-content: space-between; }\n\n.tab-links { display: flex; gap: 10px; align-items: center; }\n.tab-actions { display: flex; gap: 8px; align-items: center; }\n\n.btab {\n  border: none;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 8px;\n  background: #e2e8f0;\n  color: #334155;\n\tfont-weight: 600;\n\t/* match other action buttons */\n\tfont-family: Inter, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n\tfont-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.btab:hover {\n  background: #cbd5e1;\n}\n\n.btab.active {\n  background: #0369a1;\n  color: #ffffff;\n}\n\n/* make primary buttons show same dark-blue active state as the builder tab */\n.btn:not(.btn-secondary):active,\n.btn:not(.btn-secondary):focus,\n.controls > .btn:not(.btn-secondary):active,\n.controls > .btn:not(.btn-secondary):focus,\n.sidebar-controls > .btn:not(.btn-secondary):active,\n.sidebar-controls > .btn:not(.btn-secondary):focus {\n\tbackground: #0369a1;\n\tcolor: #ffffff;\n\tbox-shadow: 0 8px 20px rgba(3,105,161,0.12);\n\ttransform: translateY(0);\n}\n\n/* keyboard focus visible state */\n.btn:focus-visible {\n\toutline: none;\n\tbox-shadow: 0 0 0 4px rgba(3,105,161,0.12), 0 8px 20px rgba(3,105,161,0.12);\n}\n\n.a3sheet {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  margin-top: 12px;\n  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.08);\n}\n\n.sheet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.htitle {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.hsub {\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.a3grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.box {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.box h3 {\n  margin: 0 0 12px 0;\n  display: flex;\n  align-items: center;\n  color: #0f172a;\n  font-size: 14px;\n}\n\n.num {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #e0eaf3;\n  color: #0369a1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0;\n  font-size: 12px;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.preview-content {\n  white-space: pre-wrap;\n  line-height: 1.55;\n  color: #334155;\n  font-size: 13px;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  word-wrap: break-word;\n  hyphens: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.a3-body .a3grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .a3grid {\n    grid-template-columns: 1fr;\n  }\n\n\t.builder-tabs {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t\tgap: 8px;\n\t}\n\n\t.tab-actions { justify-content: flex-start; }\n}\n\n.b-section{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:18px 20px;box-shadow:var(--shadow);margin-bottom:16px}\n  .b-section h3{margin:0 0 14px;font-size:12.5px;font-weight:800;color:var(--primary-dark);text-transform:uppercase;letter-spacing:.03em;display:flex;align-items:center;gap:8px}\n\t.b-section h3 .num{width:19px;height:19px;border-radius:50%;background:var(--primary);color:#fff;font-size:10.5px;display:inline-flex;align-items:center;justify-content:center;font-weight:800}\n  .b-section label{display:block;font-size:11px;font-weight:800;color:var(--heading);margin:12px 0 5px}\n  .b-section label:first-of-type{margin-top:0}\n  .b-section input[type=text],.b-section input[type=number],.b-section textarea,.b-section select{width:100%;border:1.5px solid var(--border);border-radius:8px;padding:8px 10px;font-size:12.5px}\n  .b-section textarea{resize:vertical;min-height:64px}\n  .b-section label.chk{display:flex;align-items:center;gap:6px;font-weight:700}\n  .b-section label.chk input[type=checkbox]{width:auto}\n  .b-grid2{display:grid;grid-template-columns:1fr 1fr;gap:0 16px}\n  .b-grid2 .fullwidth{grid-column:1/-1}\n\n/* Tighter A3 visual refinements */\n.b-section {\n\tbackground: #ffffff;\n\tborder: 1px solid #e6eef6;\n\tborder-radius: 12px;\n\tpadding: 16px;\n\tbox-shadow: 0 6px 18px rgba(3,37,63,0.04);\n}\n.b-section h3 { font-size: 13px; letter-spacing: 0.02em; color: #062a44; }\n.b-section label { font-size: 12px; color: #0b3746; margin: 8px 0 6px; display:block; font-weight:700 }\n.b-section input[type=text], .b-section input[type=number], .b-section select, .b-section textarea {\n\theight: 36px; padding: 8px 10px; font-size: 13px; border-radius: 8px; border: 1px solid #d7e6ef;\n\tbackground: #fbfdff;\n}\n.b-section textarea { min-height: 72px; padding-top: 10px; padding-bottom: 10px }\n.b-section input[disabled] { background: #f3f7fa; color: #5b6b73 }\n.b-grid2 { grid-auto-rows: minmax(36px, auto); gap: 10px 16px }\n\n/* table styles inside preview to look more like Word tables */\n.a3table { width: 100%; border-collapse: collapse; margin-top: 6px; table-layout: fixed; }\n.a3table th, .a3table td { padding: 8px 10px; border: 1px solid #e6eef6; font-size: 15px; font-family: inherit; font-weight: normal; text-align: left; word-break: break-word; overflow-wrap: anywhere; word-wrap: break-word; white-space: pre-wrap; hyphens: auto; }\n.a3table thead th { background: #f1f7fb; color: #093241; font-weight:700 }\n\n/* metric chips */\n.metric-strip { display:flex; gap:8px; margin-top:8px }\n.metric-chip { padding:6px 10px; background:#eef6fb; border-radius:999px; font-weight: normal; color:#063247; font-size:15px; font-family: inherit; }\n.metric-chip.good { background:#ecfdf5; color:#065f46 }\n.metric-chip.bad { background:#fff7f5; color:#9b1c1c }\n\n/* status badges */\n.status-badge { display:inline-block; padding:4px 10px; border-radius:999px; font-weight:800; font-size:12px; color:#fff }\n.status-badge.completed { background: #10b981 }\n.status-badge.inprogress { background: #f59e0b }\n.status-badge.notstarted { background: #64748b }\n\n/* savings card */\n.savings-card { border-radius: 8px; background: linear-gradient(180deg,#f8fafc,#ffffff); padding: 12px; display:flex; flex-direction:column; align-items:flex-end; justify-content:center; width:180px; border:1px solid #e6eef6 }\n.savings-card.empty { opacity: 0.7 }\n.savings-card .amt { font-size: 18px; font-weight:800; color:#073047 }\n.savings-card .lbl { font-size:12px; color:#64748b }\n\n/* lighter blue savings card inside Results section */\n.savings-card-dark {\n  border-radius: 10px;\n  background: #0369a1;\n  padding: 14px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;  /* fill the full height of the parent flex row */\n  min-width: 180px;\n  box-shadow: 0 4px 14px rgba(3,37,63,0.18);\n}\n.savings-card-dark .scd-amt {\n  font-size: 22px;\n  font-weight: 900;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n  line-height: 1.1;\n}\n.savings-card-dark .scd-lbl {\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(255,255,255,0.72);\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* Results section box layout: content on left, savings card fills full right side */\n.results-box {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n}\n.results-box-content {\n  flex: 1;\n  padding-right: 16px;\n}\n.results-box-savings {\n  display: flex;\n  flex-shrink: 0;\n}\n.results-box-savings .savings-card-dark {\n  border-radius: 8px;\n  width: 160px;\n  min-height: 100%;\n}\n\n/* row inside Results heading area to push savings card to the right */\n.results-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n/* small helper spacing */\n.box-content {\n  font-size: 15px;\n  font-family: inherit;\n  font-weight: normal;\n  color: #153241;\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  word-wrap: break-word;\n  hyphens: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n\n/* New: section heading styled as pill with number */\n.section-heading-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n\n    padding: 8px 12px;\n    border-radius: 999px;\n\n    background: none;\n\n    color: #174a78;   /* Legacy blue */\n    font-weight: 800;\n    font-size: 15px;\n\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n.section-heading-button .num {\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 50%;\n\tbackground: #e0eaf3 !important;\n\tcolor: #0369a1 !important;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tfont-weight: 900;\n\tmargin-right: 0;\n}\n\n/* Restyle main form action buttons to match the heading pill style */\n.form-button {\n\tbackground: #0369a1;\n\tcolor: #fff;\n\tpadding: 10px 18px;\n\tborder-radius: 999px;\n\tborder: none;\n\tfont-weight: 700;\n\tbox-shadow: 0 8px 22px rgba(3,105,161,0.18);\n}\n.form-button:hover { background: #025a8a; transform: translateY(-2px); box-shadow: 0 12px 30px rgba(3,105,161,0.26); }\n.form-button:active { background: #024f7a; transform: translateY(0); }\n\n.cancel-button {\n\tbackground: #fff !important;\n\tcolor: #4b5563 !important;\n\tborder: 1px solid #d1d5db !important;\n\tbox-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;\n\tmargin-right: 8px;\n}\n.cancel-button:hover {\n\tbackground: #f9fafb !important;\n\tborder-color: #9ca3af !important;\n\tcolor: #1f2937 !important;\n}\n\n/* Inline single-line preview header (Industrial Engineer, Site/DC, Date, Status, Title) */\n.preview-inline-header {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tgap: 18px;\n\tpadding: 6px 8px 12px 8px;\n\tborder-bottom: 2px solid rgba(6,55,80,0.08); /* underline */\n}\n\n.preview-inline-header .preview-inline-item { display: flex; flex-direction: column; min-width: 80px; }\n.preview-inline-header .title-only { display:flex; flex-direction: column; align-items: flex-start; justify-content: center; min-width: 360px; min-height: 44px; }\n.preview-inline-header .title-value { font-size: 18px; font-weight: 900; color: #032d44; text-align: left; }\n.preview-inline-header .preview-inline-item.title-only label { display: none; }\n.preview-inline-header .preview-inline-item.title-only .preview-inline-value { padding: 0; }\n.preview-inline-right { display:flex; align-items:flex-end; gap:10px; margin-left: auto; }\n.preview-inline-header label { font-size: 12px; font-weight: 800; color: #0a3042; margin-bottom: 4px; }\n.preview-inline-value { font-size: 15px; font-family: inherit; font-weight: normal; color: #062a44; word-break: break-word; overflow-wrap: anywhere; max-width: 100%; }\n.preview-inline-value .placeholder { color: #64748b; font-weight: normal; }\n.placeholder { color: #64748b; font-style: italic; font-weight: normal; font-size: 15px; font-family: inherit; }\n\n/* Layout helpers used by both A3Builder preview and A3Detail */\n.left-col,\n.right-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.full-width-row {\n  display: block;\n}\n\n@media (max-width: 980px) {\n\t.preview-inline-header { flex-direction: column; align-items: stretch; gap: 8px; }\n\t.preview-inline-header .title-item { margin-left: 0; }\n}\n\n.box .section-heading-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 12px;\n    border-radius: 999px;\n    background: none;\n    color: #092135;\n    font-weight: 800;\n    font-size: 13px;\n    margin-bottom: 12px;\n}\n\n.box .section-heading-button,\n.b-section .section-heading-button {\n    color: #174a78 !important;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: .03em;\n}\n\n.box .section-heading-button .num,\n.b-section .section-heading-button .num {\n    background: #215f99 !important;\n    color: #fff !important;\n}\n\n/* =========================\n   Common Reusable Patterns\n========================= */\n\n/* Field Container */\n.a3-field-container {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Grid Layouts */\n.a3-grid-2col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.a3-grid-gap {\n  display: grid;\n  gap: 12px;\n}\n\n.a3-grid-gap-mb {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.a3-flex-col-gap {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Section Description */\n.a3-section-description {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 12px;\n  color: #64748b;\n  margin: 0 0 10px 0;\n}\n\n.a3-section-description-no-margin {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 12px;\n  color: #64748b;\n  margin: 0;\n}\n\n/* Required Field Asterisk */\n.a3-required-asterisk {\n  color: #d32f2f;\n  margin-left: 4px;\n  font-weight: bold;\n}\n\n/* Add Button Icon */\n.a3-add-button-icon {\n  font-size: 22px;\n  line-height: 1;\n  font-weight: 400;\n}\n\n/* Not Documented Placeholder */\n.a3-not-documented {\n  font-style: italic;\n  font-weight: 400;\n  color: #64748b;\n}\n\n/* Row Container with Flex End */\n.a3-row-container {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n/* Flex Layouts */\n.a3-flex-center-gap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Metric Input Width */\n.a3-metric-input {\n  width: 60%;\n}\n\n/* Metric Flag Label */\n.a3-metric-flag-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #000000;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n/* Metric Flag Checkbox */\n.a3-metric-flag-checkbox {\n  accent-color: #dc2626;\n  width: 14px;\n  height: 14px;\n}\n\n/* Preview Subtitle */\n.a3-preview-subtitle {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  margin-top: 3px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n/* Min Width Helpers */\n.a3-min-width-80 {\n  min-width: 80px;\n}\n\n.a3-min-width-60 {\n  min-width: 60px;\n}\n\n/* Margin Top Helper */\n.a3-mt-8 {\n  margin-top: 8px;\n}\n\n.a3-mt-12 {\n  margin-top: 12px;\n}\n\n.a3-mt-16 {\n  margin-top: 16px;\n}\n\n/* Text Align */\n.a3-text-left {\n  text-align: left;\n}\n\n/* Results Box Padding */\n.results-box-padding {\n  padding: 16px;\n  flex: 1;\n}\n\n/* Results Section Heading Margin */\n.results-heading-margin {\n  margin: 0 0 10px 0;\n}\n\n/* Results Box Container */\n.results-box-flex-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
